import { Currency, Money } from '@catawiki/runtime-toolkit';
import { I18nInstance } from '@catawiki/cata-style';

export const toDateTime = (
  i18nInstance: I18nInstance,
  key: string,
  value: string | number | Date
): string => i18nInstance.toTime(key, value);

export const toPercentage = (
  i18nInstance: I18nInstance,
  value: number,
  options?: I18n.ToPercentageOptions
): string => i18nInstance.toPercentage(value, options);

export const toNumber = (
  i18nInstance: I18nInstance,
  value: number,
  options: I18n.ToNumberOptions
): string => i18nInstance.toNumber(value, options);

export const toCurrency = (
  i18nInstance: I18nInstance,
  value: number,
  currency: Currency.CurrencyCode,
  options?: Parameters<typeof Money.toCurrency>[3]
): string => Money.toCurrency(i18nInstance, value, currency, options);
